import type { Namespace } from '../types';

// Fleet overview — the cloud landing page (R-085). DE drafted — queued for review.
export const overview = {
  title: { de: 'Standort-Übersicht', en: 'Fleet Overview' },
  desc: {
    de: 'Alle Standorte auf einen Blick: Gesundheitsstatus, offene Alarme und Klimalage — kritischste zuerst.',
    en: 'Every site at a glance: health, open alarms and climate state — most critical first.',
  },

  // Fleet KPI strip
  kpiSites: { de: 'Standorte meldend', en: 'Sites reporting' },
  kpiCritical: { de: 'Kritische Alarme', en: 'Critical alarms' },
  kpiWarning: { de: 'Warnungen', en: 'Warning alarms' },
  kpiIncidents: { de: 'P1/P2 Störungen', en: 'P1/P2 incidents' },
  kpiRoomsInBand: { de: 'Räume im Band', en: 'Rooms in band' },

  // Header action → Cockpit (the "TRENDS" half of the dashboard pair)
  viewTrends: { de: 'Trends ansehen', en: 'View trends' },

  // Silent-site banner (a site stopped uplinking — the loudest fleet signal)
  bannerOne: { de: '{site} meldet nicht', en: '{site} is not reporting' },
  bannerMany: { de: '{count} Standorte melden nicht', en: '{count} sites are not reporting' },
  bannerLastUplink: { de: 'letzter Uplink {ago}', en: 'last uplink {ago}' },

  // Site board
  sitesTitle: { de: 'Standorte', en: 'Sites' },
  healthCritical: { de: 'Kritisch', en: 'Critical' },
  healthWarning: { de: 'Warnung', en: 'Warning' },
  healthStale: { de: 'Keine Daten', en: 'No data' },
  healthHealthy: { de: 'Gesund', en: 'Healthy' },
  healthDisabled: { de: 'Deaktiviert', en: 'Disabled' },
  cardRooms: { de: 'Räume im Band', en: 'Rooms in band' },
  cardLastSeen: { de: 'Letzte Telemetrie', en: 'Last telemetry' },
  neverReported: { de: 'nie gemeldet', en: 'never reported' },
  openSite: { de: 'Standort öffnen', en: 'Open site' },
  sitesEmpty: { de: 'Keine Standorte registriert.', en: 'No sites registered.' },
  sitesEmptyMsg: {
    de: 'Standorte erscheinen hier, sobald sie in der Cloud registriert sind.',
    en: 'Sites appear here once they are registered in the cloud.',
  },

  // Alarm feed (visible with maintenance read permission)
  feedTitle: { de: 'Aktive Alarme (alle Standorte)', en: 'Active alarms (all sites)' },
  feedColAlarm: { de: 'Alarm', en: 'Alarm' },
  feedColAction: { de: 'Aktion', en: 'Action' },
  feedEmpty: { de: 'Keine offenen Alarme.', en: 'No open alarms.' },
  feedOpenSoc: { de: 'Im SOC öffnen', en: 'Open in SOC' },
  ack: { de: 'Bestätigen', en: 'Acknowledge' },
  toastAcked: { de: 'Alarm bestätigt.', en: 'Alarm acknowledged.' },
  sevWarning: { de: 'Warnung', en: 'Warning' },
  sevCritical: { de: 'Kritisch', en: 'Critical' },

  loadError: { de: 'Übersicht nicht erreichbar', en: 'Overview unavailable' },
  loadErrorMsg: {
    de: 'Die Flotten-Übersicht konnte nicht geladen werden. Bitte erneut versuchen.',
    en: 'The fleet overview could not be loaded. Please retry.',
  },
} as const satisfies Namespace;
